import {
  type CurrencyName,
  CurrencyNames,
} from '@webapp/core/entities/external/Currency'
import {
  FinancialAccountStatuses,
  type FinancialAccountStatusEnum,
} from '../enums/FinancialAccountStatusEnum'
import {
  FinancialAccountTypes,
  type FinancialAccountTypeEnum,
} from '../enums/FinancialAccountTypeEnum'

const canadaFlag = require('../../assets/images/canada.svg')
const ukFlag = require('../../assets/images/uk.svg')
const unitedStatesFlag = require('../../assets/images/united_states.svg')

export interface FinancialAccountConstructor {
  id: number
  type: FinancialAccountTypeEnum
  status: FinancialAccountStatusEnum
}

export class FinancialAccount {
  id: number
  type: FinancialAccountTypeEnum
  status: FinancialAccountStatusEnum

  constructor(data: FinancialAccountConstructor) {
    this.id = data.id
    this.type = data.type
    this.status = data.status
  }

  get isActive(): boolean {
    return this.status === FinancialAccountStatuses.ACTIVE
  }

  get isInactive(): boolean {
    return this.status === FinancialAccountStatuses.INACTIVE
  }

  get isVerificationPending(): boolean {
    return this.status === FinancialAccountStatuses.VERIFICATION_PENDING
  }

  get isOnboarding(): boolean {
    return this.status === FinancialAccountStatuses.ONBOARDING
  }

  get isActionRequired(): boolean {
    return this.status === FinancialAccountStatuses.ACTION_REQUIRED
  }

  get isCreated(): boolean {
    return this.status === FinancialAccountStatuses.CREATED
  }

  get isPlaceholder(): boolean {
    return this.status === FinancialAccountStatuses.PLACEHOLDER
  }

  get currencyLabel(): CurrencyName {
    switch (this.type) {
      case FinancialAccountTypes.AIRWALLEX_USD:
        return CurrencyNames.USD
      case FinancialAccountTypes.AIRWALLEX_CAD:
        return CurrencyNames.CAD
      case FinancialAccountTypes.AIRWALLEX_GBP:
        return CurrencyNames.GBP
    }
  }

  get currencyIcon(): string {
    switch (this.type) {
      case FinancialAccountTypes.AIRWALLEX_USD:
        return unitedStatesFlag
      case FinancialAccountTypes.AIRWALLEX_CAD:
        return canadaFlag
      case FinancialAccountTypes.AIRWALLEX_GBP:
        return ukFlag
    }
  }
}
